import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { StateService } from "@core-services/state.service";
import { NotificationsCountModel } from "@modules/notifications/domain/entities/notifications.model";

const initialState: NotificationsCountModel | null = null;

@Injectable({
	providedIn: "root"
})
export class NotificationsStateService extends StateService<NotificationsCountModel> {
	constructor() {
		super(initialState);
	}

	public getState$(): Observable<NotificationsCountModel> {
		return this.select((state) => state);
	}

	public saveState(data: NotificationsCountModel): void {
		this.setState(data);
	}
}
